import { render, staticRenderFns } from "./konv.vue?vue&type=template&id=6347ebb1"
import script from "./konv.vue?vue&type=script&lang=js"
export * from "./konv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports